import { Controller } from "@hotwired/stimulus"
import Cropper from "cropperjs"

export default class extends Controller {
  static targets = ["input", "modal", "cropImage", "form"]

  connect() {
    this.cropper = null
  }

  disconnect() {
    this.destroyCropper()
  }

  fileSelected(event) {
    const file = event.target.files[0]
    if (!file) return
    if (!file.type.match(/^image\/(jpeg|png|webp|gif)$/)) return

    this.originalFile = file
    const url = URL.createObjectURL(file)
    this.cropImageTarget.src = url
    this.modalTarget.classList.add("avatar-crop-modal--open")
    document.body.style.overflow = "hidden"

    this.cropImageTarget.onload = () => {
      this.destroyCropper()
      this.cropper = new Cropper(this.cropImageTarget, {
        viewMode: 1,
        dragMode: "move",
        aspectRatio: 1,
        autoCropArea: 0.85,
        responsive: true,
        restore: false,
        guides: false,
        center: true,
        highlight: false,
        cropBoxMovable: true,
        cropBoxResizable: true,
        toggleDragModeOnDblclick: false,
        minContainerWidth: 250,
        minContainerHeight: 250,
      })
    }
  }

  confirm() {
    if (!this.cropper) return

    const canvas = this.cropper.getCroppedCanvas({
      width: 400,
      height: 400,
      imageSmoothingEnabled: true,
      imageSmoothingQuality: "high",
    })

    canvas.toBlob((blob) => {
      if (!blob) return

      const file = new File([blob], "avatar.jpg", { type: "image/jpeg" })
      const dt = new DataTransfer()
      dt.items.add(file)
      this.inputTarget.files = dt.files

      this.closeModal()
      this.formTarget.requestSubmit()
    }, "image/jpeg", 0.92)
  }

  cancel() {
    this.inputTarget.value = ""
    this.closeModal()
  }

  closeModal() {
    this.modalTarget.classList.remove("avatar-crop-modal--open")
    document.body.style.overflow = ""
    this.destroyCropper()
  }

  destroyCropper() {
    if (this.cropper) {
      this.cropper.destroy()
      this.cropper = null
    }
  }
}
